// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"35ef41f11f26cec064d1","691":"fb0d8851deb482e27727"}[chunkId] + ".js";
};